import VendorDetailContainer from "./VendorDetailContainer";
export default VendorDetailContainer;
